module.exports = __webpack_public_path__ + "static/cai_flow_framework-5b73821ee348933da2038ec92d28e37d.png";